import { Injectable } from '@angular/core';
import { ExportAsService } from 'ngx-export-as';
import { ConstantProvider } from './constant.provider';
import { FuseConfirmationService } from '@fuse/services/confirmation';
// import { ConstantProvider } from './constant.provider';

@Injectable({
    providedIn: 'root',
})
export class PdfReportProvider {

    constructor(private constants: ConstantProvider, private exportAsService: ExportAsService,     private fuseConfirmationService: FuseConfirmationService,) {
    }

    downloadReport(exportAsConfig, nombre) {
        return new Promise((resolve, reject) => {
            this.exportAsService.save(exportAsConfig, nombre ).subscribe(
                result => {
                    resolve(result);
                },
                error => {
                    const confirmation = this.fuseConfirmationService.open({
                        title  : 'Error',
                        message: error.error.Message,
                        icon: {
                            show: true,
                            name : 'heroicons_solid:exclamation',
                            color: 'error'
                        },
                        actions: {
                            confirm: {
                                label: 'Aceptar',
                                color: 'primary'
                            },
                            cancel:{
                                show: false
                            }
                        }
                    });
                    reject();
                }
            );
        });
    }
}
